import baseStylesheet, { ThemeStylesheet } from "./base";

const sarkanniemiStylesheet: ThemeStylesheet = {
  ...baseStylesheet,
};

export default sarkanniemiStylesheet;
